/**
 * 複数ページに跨るツアーの進行状態を sessionStorage で保持する。
 * - HomePage(welcome → services-nav) → /services への遷移時に save
 * - ServicesPage(favorite → tag → search) → /dashboard への遷移時に save
 * - 各ページ受け側の useEffect が load して startStep から再開
 * - resume 直後に clear して、最終ステップ完了時の onDestroyed で完了処理が走るようにする
 */

const TOUR_STATE_KEY = "ai-deck-tour-state";

export type TourState = {
  tour: "deck";
  startStep: number;
};

export const saveTourState = (state: TourState): void => {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(TOUR_STATE_KEY, JSON.stringify(state));
};

export const loadTourState = (): TourState | null => {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(TOUR_STATE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as TourState;
  } catch {
    return null;
  }
};

export const clearTourState = (): void => {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(TOUR_STATE_KEY);
};
